<template>
  <section :ref="setRef">
    <el-carousel class="index_carousel" height="420px" :interval="5000">
      <el-carousel-item>
        <div class="banana">
          <canvas-particle height="420" />
          <div class="box">
            <div class="dreamtxt">
              <img src="@/assets/img/culture_01.png" draggable="false" alt="有" class="wcani" data-delay='0'
                data-ani="indown">
              <img src="@/assets/img/culture_02.png" draggable="false" alt="理" class="wcani" data-delay='0.1'
                data-ani="indown">
              <img src="@/assets/img/culture_03.png" draggable="false" alt="想" class="wcani" data-delay='0.2'
                data-ani="indown">
              <img src="@/assets/img/culture_04.png" draggable="false" alt="超" class="wcani" data-delay='0.4'
                data-ani="indown">
              <img src="@/assets/img/culture_05.png" draggable="false" alt="越" class="wcani" data-delay='0.5'
                data-ani="indown">
              <img src="@/assets/img/culture_06.png" draggable="false" alt="梦" class="wcani" data-delay='0.6'
                data-ani="indown">
              <img src="@/assets/img/culture_07.png" draggable="false" alt="想" class="wcani" data-delay='0.7'
                data-ani="indown">
            </div>
            <img class="banana_bg" src="@/assets/img/bananabg.jpg" alt="">
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="crumbs">
      <ul>
        <li>
          <img src="@/assets/img/about_01.png" alt="愿景">
          <div>
            <i>愿景</i>
            <span>勇于挑战，不畏将来</span>
          </div>
        </li>
        <li>
          <img src="@/assets/img/about_02.png" alt="使命">
          <div>
            <i>使命</i>
            <span>有理想，超越梦想</span>
          </div>
        </li>
        <li>
          <img src="@/assets/img/about_03.png" alt="价值观">
          <div>
            <i>价值观</i>
            <span>科技有限，瑞思无限</span>
          </div>
        </li>
      </ul>
    </div>
  </section>

  <section class="section about" :ref="setRef">
    <h4 class="titel wcani" data-text="about resee" data-delay='0' data-ani="indown">关于瑞思</h4>
    <div class="box">
      <img class="l wcani" data-delay='0.2' data-ani="inRight" src="@/assets/img/logo_01.png">
      <div class="r">
        <p class="wcani" data-delay='0.4' data-ani="inUp">
          萍乡市瑞思软件科技有限公司（简称瑞思）成立于2018年，是以互联网产品开发与数字化咨询、用户体验设计为主营业务的互联网技术服务企业。业务涉及中大型信息系统建设、商用高端APP定制开发，微信小程序开发、智慧城市、产品孵化等领域，瑞思坚持“用户体验至上”为服务理念，将互联网高新技术与行业特点相结合，为加速行业创新变革，助力企业数字化转型升级，为客户创造更多的商业价值。
        </p>
        <p class="wcani" data-delay='0.6' data-ani="inUp">
          我们的客户来自各行各业，每一位客户都是与瑞思并肩前行的伙伴，感谢他们从不同领域给我们带来的挑战，让我们积累了丰富经验，共同探索未来，将客户体验不断推向至臻之境。</p>
        <ul class="culture wcani" data-delay='0.6' data-ani="inShow">
          <li @mouseenter="cultuerEnter(0)" @mouseleave="cultuerLeave(0)">
            <div class="pointer wcani" :style="getCultureStyle(0)" data-delay='0' data-ani="indown">
              <img class="img" src="@/assets/img/about_01.png" alt="愿景">
              <i>愿景</i>
              <span>勇于挑战，不畏将来</span>
            </div>
            <div class="hover">因为无知所以恐惧，真正让我们畏惧未来变化的是对科技的无知，只要我们保持一颗永远学习的心，就能从容应对来自不同领域客户带来的技术难题</div>
          </li>
          <li @mouseenter="cultuerEnter(1)" @mouseleave="cultuerLeave(1)">
            <div class="pointer wcani" :style="getCultureStyle(1)" data-delay='0.2' data-ani="indown">
              <img class="img" src="@/assets/img/about_02.png" alt="使命">
              <i>使命</i>
              <span>有理想，超越梦想</span>
            </div>
            <div class="hover">如果梦想是五彩斑斓的泡泡，那么理想就是无比坚固的城墙，我们有着天马行空的梦想，也有化梦想为现实的理想</div>
          </li>
          <li @mouseenter="cultuerEnter(2)" @mouseleave="cultuerLeave(2)">
            <div class="pointer wcani" :style="getCultureStyle(2)" data-delay='0.4' data-ani="indown">
              <img class="img" src="@/assets/img/about_03.png" alt="价值观">
              <i>价值观</i>
              <span>科技有限，瑞思无限</span>
            </div>
            <div class="hover">科技有限但梦想无限，在实现梦想的过程才让科技变得无限而富有价值，瑞思为有梦想的伙伴实现梦想</div>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <section class="section business" :ref="setRef">
    <h4 class="titel wcani" data-text="Business Introduction" data-delay='0' data-ani="indown">我们能做什么</h4>
    <div class="box">

      <ul class="business_tabs wcani" data-delay='0' data-ani="indown">
        <li :class="activeName == 0 ? 'active' : ''" @click="businessTabsChang(0)">
          <el-icon>
            <Trophy />
          </el-icon>
          <span>咨询服务</span>
        </li>
        <li :class="activeName == 1 ? 'active' : ''" @click="businessTabsChang(1)">
          <el-icon>
            <Brush />
          </el-icon>
          <span>应用开发</span>
        </li>
        <li :class="activeName == 2 ? 'active' : ''" @click="businessTabsChang(2)">
          <el-icon>
            <Suitcase />
          </el-icon>
          <span>人员外包</span>
        </li>
        <li :class="activeName == 3 ? 'active' : ''" @click="businessTabsChang(3)">
          <el-icon>
            <MagicStick />
          </el-icon>
          <span>智慧城市</span>
        </li>
        <li :class="activeName == 4 ? 'active' : ''" @click="businessTabsChang(4)">
          <el-icon>
            <Timer />
          </el-icon>
          <span>解决方案</span>
        </li>
      </ul>

      <div class="wcani" data-delay='0' data-ani="inRight">
        <div class="business_main" v-if="activeName == 0" data-ani="inLeft">
          <div class="l">
            <h3>咨询服务</h3>
            <p>
              随着数字化经济的快速发展，科技正在迅速的改变的各行各业，瑞思聚集“可落地咨询”，致力于为客户提出的咨询项目等提供专业化、可执行性强、一体化的管理和IT咨询服务，覆盖从设计到交付的整个项目生命周期，包括需求定义、同行竞品分析、技术可行性判断、设计与开发、变更与发布、质量管理、安全与循规管理等。
            </p>
          </div>
          <ul class="r">
            <li>
              <el-icon size="48" color="#666">
                <Help />
              </el-icon>
              <p>项目策划咨询</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>项目需求调研</p>
            </li>
          </ul>
        </div>
        <div class="business_main" v-else-if="activeName == 1" data-ani="inLeft">
          <div class="l">
            <h3>应用开发</h3>
            <p>
              凭借专业的技术经验和行业领先的质量保障措施，为客户提供全方位的应用软件开发和维护服务，我们有经验丰富的开发团队、工程师和技术支持团队，我们应用开发服务涵盖开发能够帮助客户确定对应用系统或产品的具体需求，
              并管理和维护其整个生命周期，进而满足客户的业务目标。
            </p>
          </div>
          <ul class="r">
            <li>
              <el-icon size="48" color="#666">
                <Help />
              </el-icon>
              <p>小程序开发</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>APP开发</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>软件开发</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>网站开发</p>
            </li>
          </ul>
        </div>
        <div class="business_main" v-else-if="activeName == 2" data-ani="inLeft">
          <div class="l">
            <h3>人员外包</h3>
            <p>
              基于瑞思多年经验背书，打造人力资源外包线上转型新模式。升级传统外包服务模式，为客户提供快速、高质量的服务。涵盖人员招聘、驻厂开发、技术支持，服务支撑、线上考勤、线上绩效、在线结算等，一站式人力资源管理服务。
            </p>
          </div>
          <ul class="r">
            <li>
              <el-icon size="48" color="#666">
                <Help />
              </el-icon>
              <p>UI设计师</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>前端开发工程师</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>Android/IOS工程师</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>JAVA/PHP架构师</p>
            </li>
          </ul>
        </div>
        <div class="business_main" v-else-if="activeName == 3" data-ani="inLeft">
          <div class="l">
            <h3>智慧城市</h3>
            <p>
              在城市规划、设计、建设、管理与运营等领域中，通过物联网、云计算、大数据、空间地理信息集成等智能计算技术的应用，使得城市管理、教育、医疗、房地产、交通运输、公用事业和公众安全等城市组成的关键基础设施组件和服务更互联、高效和智能，从而为市民提供更美好的生活和工作服务、为企业创造更有利的商业发展环境、为政府赋能更高效的运营与管理机制。
            </p>
          </div>
          <ul class="r">
            <li>
              <el-icon size="48" color="#666">
                <Help />
              </el-icon>
              <p>智慧城市系统</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>智慧园区开发</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>智慧家居平台</p>
            </li>
          </ul>
        </div>
        <div class="business_main" v-else-if="activeName == 4" data-ani="inLeft">
          <div class="l">
            <h3>解决方案</h3>
            <p>
              疫情过后，企业面临各种压力，瑞思行业解决方案致力于应用智能技术，助力企业实现传统行业数字化转型，重塑企业核心竞争力。
            </p>
          </div>
          <ul class="r">
            <li>
              <el-icon size="48" color="#666">
                <Help />
              </el-icon>
              <p>物联应用</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>新零售</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>文化旅游</p>
            </li>
            <li>
              <el-icon size="48" color="#666">
                <SetUp />
              </el-icon>
              <p>生产制造</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- 研发优势 -->
  <section class="section research" :ref="setRef">
    <h4 class="titel wcani" data-text="research and development" data-delay='0' data-ani="indown">瑞思研发优势</h4>

    <ul class="research_ul wcani" data-delay='0' data-ani="inUp">
      <li>
        <div class="coneter">
          <el-icon size="48">
            <Help />
          </el-icon>
          <p>多平台定制</p>
          <p class="text">APP / IOS / Android / 微信 / PC / 手机站 / 微商城</p>
        </div>
        <img class="bg" src="@/assets/img/research_01.jpg" alt="多平台定制">
      </li>
      <li>
        <div class="coneter">
          <el-icon size="48">
            <SetUp />
          </el-icon>
          <p>高效技术开发</p>
          <p class="text">原型策划 / Ui设计 / 程序开发 / 系统测试 / 质量监督 / 迭代运维</p>
        </div>
        <img class="bg" src="@/assets/img/research_02.jpg" alt="高效技术开发">
      </li>
      <li>
        <div class="coneter">
          <el-icon size="48">
            <SetUp />
          </el-icon>
          <p>成熟系统架构</p>
          <p class="text">Linux系统 / Apaeche服务器 / Nginx服务器 / PHP / Java / Nodejs</p>
        </div>
        <img class="bg" src="@/assets/img/research_03.jpg" alt="成熟系统架构">
      </li>
      <li>
        <div class="coneter">
          <el-icon size="48">
            <SetUp />
          </el-icon>
          <p>服务器方案</p>
          <p class="text">分布式数据库服务器 / 大数据负载 / 全球节点接入</p>
        </div>
        <img class="bg" src="@/assets/img/research_04.jpg" alt="服务器方案">
      </li>
      <li>
        <div class="coneter">
          <el-icon size="48">
            <SetUp />
          </el-icon>
          <p>全程服务支持</p>
          <p class="text">售前咨询 / 需求分析 / 团队建设 / 问题处理 / 售后支持 / 迭代建议</p>
        </div>
        <img class="bg" src="@/assets/img/research_05.jpg" alt="全程服务支持">
      </li>
    </ul>
  </section>

  <!-- 精彩案例 -->
  <section class="section cases" :ref="setRef">
    <h4 class="titel wcani" data-text="Wonderful cases" data-delay='0' data-ani="indown">我们的案例</h4>
    <div class="box">
      <ul class="cases_ul">
        <li v-for="(item, index) in caseList['list']" :key="index"
          @click="$openFrame('/case_details', { 'title': item['text'] })">
          <img class="cases_img" :src="item['src']" alt="">
          <p> {{ item['text'] }} </p>
        </li>
      </ul>
    </div>
    <el-button size="large" type="primary" @click="$openFrame('/case')">
      &nbsp;&nbsp;&nbsp;&nbsp;了解更多案例&nbsp;&nbsp;
      <el-icon>
        <Right />
      </el-icon>
      &nbsp;&nbsp;
    </el-button>
  </section>

  <section class="section partner" :ref="setRef">
    <h4 class="titel wcani" data-text="cooperative partner" data-delay='0' data-ani="indown">客户与伙伴</h4>
    <vue3-seamless-scroll class="seamless_scroll" :list="logosList" :step="0.3" direction="left">
      <img v-for="(item, index) in logosList" :key="index" :src="item['src']" draggable="false" />
    </vue3-seamless-scroll>
  </section>

  <section class="section contact" :ref="setRef">
    <h4 class="titel wcani" data-text="contact us" data-delay='0' data-ani="indown">联系我们</h4>
    <div class="box">
      <div id="allmap" class="wcani" data-delay='0' data-ani="inUp"></div>
      <div class="r wcani" data-delay='0.5' data-ani="inUp">
        <h3> 新的需求，从这里开始 </h3>
        <img src="@/assets/img/erweima.png" alt="瑞思公众号">
        <br>
        <p>扫一扫，关注瑞思公众号</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, getCurrentInstance, reactive, ref } from 'vue'
import { useStore } from '@/store/index'
import canvasParticle from '@/components/canvas_circle.vue'
const store = useStore()
const { proxy } = getCurrentInstance()
const cultuerIndex = reactive({
  one: true,
  two: true,
  three: true
})

const activeName = ref(0)

// 栏目数组
const sectionRef = ref([])
// 动态绑定ref到栏目数组
const setRef = (el) => { if (el) { sectionRef.value.push(el) } }

const caseList = reactive({
  list: [{
    src: require('@/assets/img/research_03.jpg'),
    text: '加佳游景点解说助手'
  }, {
    src: require('@/assets/img/research_04.jpg'),
    text: '敞价家居建材商城'
  }, {
    src: require('@/assets/img/research_01.jpg'),
    text: '何许社交APP'
  }, {
    src: require('@/assets/img/research_02.jpg'),
    text: '无限美在线化妆APP'
  }, {
    src: require('@/assets/img/research_03.jpg'),
    text: '馨禧悦母婴管理系统'
  }, {
    src: require('@/assets/img/research_04.jpg'),
    text: '瑞思流程化管理系统'
  }, {
    src: require('@/assets/img/research_01.jpg'),
    text: '江西恒昊工程管理系统'
  }, {
    src: require('@/assets/img/research_02.jpg'),
    text: '省更多一站式购物平台'
  }]
})

const logosList = ref()

onMounted(() => {
  store['indexPage'] = true
  setTabsIndex()
  proxy.$loadAnimaet('wcani')
  // 获取栏目高度
  store['sectionArrs'] = []
  for (let i = 0; i < sectionRef['value'].length; i++) {
    store['sectionArrs'].push(sectionRef['value'][i]['scrollHeight'])
  }

  // 遍历合作伙伴
  let logosarr = []
  for (let i = 1; i < 25; i++) {
    let num = i < 10 ? '0' + i : i
    logosarr.push({ src: require('@/assets/img/logos_' + num + '.png') })
  }
  logosList.value = logosarr

  SetBDMap()
})

// 关于瑞思 企业文化鼠标经过
function cultuerEnter(val) {
  let index = ['one', 'two', 'three'][val]
  cultuerIndex[index] = false
}
// 关于瑞思 企业文化鼠标离开
function cultuerLeave(val) {
  let index = ['one', 'two', 'three'][val]
  cultuerIndex[index] = true
}
// 关于瑞思 企业文化切换内容
function getCultureStyle(val) {
  let index = ['one', 'two', 'three'][val]
  return cultuerIndex[index] ? 'display:flex' : 'display:none'
}
// 业务范围的tabs切换
function businessTabsChang(val) {
  activeName.value = val
}
function SetBDMap() {
  // 按住鼠标右键，修改倾斜角和角度
  var map = new BMapGL.Map("allmap")     // 创建Map实例
  var point = new BMapGL.Point(113.873925, 27.645753);  //设置坐标
  map.centerAndZoom(point, 19);  // 初始化地图,设置中心点坐标和地图级别
  map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
  map.setHeading(64.5);
  map.setTilt(73);
  // 创建点标记
  var marker = new BMapGL.Marker(point);
  // 在地图上添加点标记
  map.addOverlay(marker);
  // 创建信息窗口
  var opts = {
    width: 200,
    height: 100,
    title: '萍乡市瑞思软件科技有限公司'
  };
  var infoWindow = new BMapGL.InfoWindow('地址：江西省萍乡市蓝天大厦1113室', opts);
  // 点标记添加点击事件
  marker.addEventListener('click', function () {
    map.openInfoWindow(infoWindow, point); // 开启信息窗口
  })
}
</script>

<style lang="less" scoped>
*::-webkit-scrollbar {
  width: 0 !important
}

// 轮播栏
.banana {
  position: relative;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);

  .banana_canvas {
    position: absolute;
    top: 0;
    left: 0;
  }

  .banana_bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    object-fit: cover;
    z-index: -1;

  }

  .box {
    display: flex;
    align-items: center;
    max-width: 1200px;
    margin: auto;
    height: 420px;

    .dreamtxt {
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 120px;
        width: 10vw;
        margin: 0 0.5vw;
      }
    }
  }
}

// 轮播下面包屑
.crumbs {
  background-color: #eee;

  ul {
    max-width: 1200px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-around;

    li {
      position: relative;
      display: flex;
      align-items: center;
      padding: 10px;

      img {
        display: inline-block;
        width: 42px;
        height: 42px;
        object-fit: contain;
        margin-right: 10px;
      }

      i {
        display: block;
        font-style: normal;
        font-weight: bold;
        color: #d02543;
      }

    }
  }
}

// 栏目公共样式
.section {
  padding: 100px 20px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;

  h4 {
    display: inline-block;
    position: relative;
    margin: 30px auto;
    font-size: 50px;
    text-align: center;
    font-weight: 100;

    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 2em;
      content: '';
      border-bottom: 5px solid #d02543;
    }

    &::before {
      position: absolute;
      content: attr(data-text);
      top: -10px;
      right: 0;
      color: rgba(0, 0, 0, 0.5);
      white-space: nowrap;
      font-weight: 50;
      font-size: 16px;
      text-transform: uppercase
    }
  }

  .box {
    display: flex;
    margin: auto;
    align-items: center;
    max-width: 1200px;
    padding: 50px;
  }
}

// 关于
.about {
  .l {
    flex-shrink: 0;
    width: 200px;
    object-fit: contain;
  }

  .r {
    padding-left: 10%;
    text-align: left;
    width: 100%;
    font-size: 16px;
    box-sizing: border-box;

    p {
      text-indent: 2em;
      line-height: 2em;
      text-align: justify;
    }
  }

  .culture {
    display: flex;
    align-items: center;
    margin-top: 50px;
    width: 100%;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    li {
      width: 100%;
      height: 200px;
      overflow: hidden;
      cursor: pointer;
    }

    .pointer {
      padding: 0 50px;
      height: 200px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;

      .img {
        display: block;
        width: 80px;
        height: 80px;
        object-fit: contain;
      }

      i {
        font-style: normal;
        color: #888;
        padding: 10px 0;
      }

      span {
        font-size: 18px;
      }
    }

    .hover {
      display: flex;
      height: 200px;
      padding: 0 20px;
      align-items: center;
      justify-content: center;
      background-color: #d02543;
      color: #fff;
    }
  }

}

// 业务介绍
.business {
  background-color: #f2f3f4;

  .box {
    display: block;
  }

  .business_tabs {
    margin-top: 30px;
    display: flex;

    li {
      padding: 20px 50px;
      width: 100%;
      font-size: 20px;
      display: flex;
      align-items: center;
      cursor: pointer;
      border-bottom: 2px solid #ddd;

      span {
        padding-left: 10px;
      }

      &:hover {
        color: #d02543;
        background-color: #eee;
      }
    }

    .active {
      position: relative;
      z-index: 2;
      color: #d02543;
      border-bottom: 2px solid #d02543;
    }

  }

  .business_main {
    display: flex;
    padding: 100px 50px 0 0;
    height: 300px;
    animation-name: inLeft;

    .l {
      text-align: left;
      max-width: 400px;

      h3 {
        display: inline-block;
        font-size: 20px;
        padding-bottom: 5px;
        margin-bottom: 20px;
        border-bottom: 2px solid #d02543;
      }

      p {
        line-height: 2em;
        text-align: justify;
      }
    }

    .r {
      width: 100%;
      display: flex;

      li {
        width: 160px;
        padding: 20px 0;

        p {
          margin-top: 10px;
        }
      }
    }
  }
}

// 研发优势
.research {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;

  .research_ul {
    padding-top: 50px;
    width: 100%;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;

    li {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 70vh;
      font-size: 28px;
      color: #fff;
      background-color: rgba(5, 13, 46, 0.2);
      transition: b 1s;
      cursor: pointer;

      .coneter {
        position: relative;
        transition: background-color 1s;
        transition: font-size .2s;
        z-index: 1;
      }

      .text {
        opacity: 0;
        font-size: 18px;
        padding: 20px;
        height: 80px;
        transition: all 1s;
      }

      .bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: -1;
      }

      &:hover,
      &:active {
        font-size: 26px;
        background-color: rgba(120, 157, 230, 0.5);

        .text {
          opacity: 1;
        }
      }

    }
  }
}

// 案例
.cases {

  .cases_ul {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;

    li {
      width: 24%;
      margin: 10px 0;
      cursor: pointer;
      transition: all .5s;

      .cases_img {
        display: block;
        width: 100%;
        height: 160px;
        object-fit: cover;
      }

      p {
        text-align: left;
        padding: 10px;
        border-bottom: 1px solid #f2f3f4;
      }

      &:hover {
        background-color: #f2f3f4;
        transform: translateY(-5px);
        box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.2);

        .cases_img {
          opacity: 0.8;
        }
      }
    }
  }

}

.partner {
  background-color: #f2f3f4;

  .seamless_scroll {
    width: 100%;
    max-width: 1200px;
    margin: 50px auto;
    height: 560px;
    overflow: hidden;
    text-align: left;

    img {
      display: inline-block;
      width: 240px;
      height: auto;
      margin: 20px;
    }
  }
}

#allmap {
  flex-shrink: 0;
  padding-top: 100px;
  width: 600px;
  height: 350px;
}

// 联系我们
.contact {
  padding-bottom: 0;

  .box {
    align-items: flex-start;
  }

  .r {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h3 {
      padding: 50px 0;
      font-size: 20px;
    }
  }
}

@media screen and (max-width: 800px) and (min-width: 300px) {
  .section {
    .box {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .about {
    .l {
      display: none;

    }

    .r {
      padding-left: 0;
    }

    .culture {
      display: block;
    }
  }


  .crumbs li {
    font-size: 10px;

    img {
      display: none !important;
    }
  }

  .business {
    .business_tabs {
      overflow-x: auto;
      overflow-y: hidden;

      li {
        font-size: 18px;
        white-space: nowrap;
      }
    }

    .business_main {
      display: block;
      padding: 100px 0;

      .r {
        display: block;
        overflow-x: auto;
        overflow-y: hidden;
        text-align: left;
        white-space: nowrap;

        li {
          margin-right: 20px;
          text-align: center;
          width: auto;
          display: inline-block;
        }
      }
    }
  }

  // 研发优势
  .research {
    .research_ul {
      li {
        flex-shrink: 0;
        font-size: 16px;

        &:hover,
        &:active {
          font-size: 18px;
        }

        .text {
          font-size: 12px;
        }
      }
    }
  }

  .cases {

    .cases_ul {
      width: 100%;
      display: block;

      li {
        width: 100%;
      }
    }
  }

  .contact {
    .box {
      display: block;
    }

    #allmap {
      width: 90%;
      height: 200px;
      margin: auto;
    }
  }
}
</style>
